import Vue from 'vue'

// Load global components dynamically, only require for standalone
const requireContext = require.context(
  '.', false, /.(OrticTable|OrticChild|OrticCard|OrticButton|OrticTableHeader|OrticPagination)\.(vue)$/
)
requireContext.keys().forEach(file => {
  const Component = requireContext(file).default

  if (Component && Component.name) {
    Vue.component(Component.name, Component)
  }
})
